<script>
  import { scaleLinear } from "d3-scale";
  import Number from "./Number.svelte";
  import data from "./../data/thermometer.csv";
  import { fromPairs } from "./../utils";
  import {
    thermometer_heading,
    thermometer_footer
  } from "./../content/data.json";

  export let year = 2100;

  const yearToTemperatureMap = fromPairs(
    data.map(({ YEAR, GMSTchange }) => [YEAR, GMSTchange.slice(0, 3)])
  );
  const maxTemp = Math.max(...data.map(d => +d["GMSTchange"]));

  const yScale = scaleLinear()
    .domain([0, maxTemp])
    .range([0, 17]);

  $: temp = yearToTemperatureMap[year];
</script>

<div class="c">
  <h6>{thermometer_heading}</h6>
  <div class="main">
    <div class="img">
      <svg viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.13607 15.4784L4.36593 15.3308V15.0577V3.75138C4.36593 2.10887
          5.69745 0.777344 7.33996 0.777344C8.98248 0.777344 10.314 2.10887
          10.314 3.75138V15.0578V15.331L10.5438 15.4785C12.1897 16.5354 13.2784
          18.3805 13.2784 20.4795C13.2784 23.7593 10.6196 26.418 7.33987
          26.418C4.06013 26.418 1.40137 23.7593 1.40137 20.4795C1.40137 18.3804
          2.49011 16.5352 4.13607 15.4784Z"
          fill="white"
          stroke="#000"></path>
        <circle cx="7.33983" cy="20.48" r="4.06786" fill="#FE3F3E"></circle>
        <line
          class="img-line"
          x1="7.33983"
          x2="7.33983"
          y1="{20.48 - yScale(temp)}"
          y2="20.48"
          stroke="#FE3F3E"></line>
        <path d="M 8 {yScale(3)} h 4.5" class="tick"></path>
        <path d="M 8 {yScale(2)} h 4.5" class="tick"></path>
        <path d="M 8 {yScale(1)} h 4.5" class="tick"></path>
        <ellipse
          cx="4.94678"
          cy="19.1362"
          rx="0.67627"
          ry="0.698683"
          fill="white"></ellipse>
      </svg>
    </div>
    <figure class="temp">
      <Number number="{temp}" />
      &deg;C
    </figure>
  </div>
  <div class="footer">{thermometer_footer}</div>
</div>

<style>
  .c {
    position: relative;
    width: 100%;
    max-width: 18em;
    text-align: left;
    font-size: 0.8em;
    pointer-events: all;
  }
  h6 {
    font-size: 0.8rem;
    line-height: 1.3em;
    margin-bottom: 0;
  }
  .main {
    display: flex;
    align-items: center;
    margin: 0.3em 0 0.9em;
  }
  .temp {
    font-size: 1.8em;
    line-height: 1.2em;
  }
  .footer {
    max-width: 30em;
    margin-left: auto;
    font-size: 0.7em;
    line-height: 1.5em;
    letter-spacing: 0;
    opacity: 0.6;
  }
  .img {
    width: 1em;
    height: 2.2em;
    margin-right: 0.5em;
  }
  .img svg {
    width: 100%;
    stroke-linecap: round;
  }
  .img-line {
    stroke-width: 2.6;
  }
  .tick {
    stroke: black;
    stroke-width: 0.6;
  }
</style>
